import React, { useState, useRef, useEffect } from 'react';
import AceEditor from 'react-ace';

// Import Ace Editor modes and themes
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-html';

import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-textmate';
import 'ace-builds/src-noconflict/theme-idle_fingers';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/theme-kuroir';
import 'ace-builds/src-noconflict/theme-twilight';
import 'ace-builds/src-noconflict/theme-xcode';
import 'ace-builds/src-noconflict/theme-solarized_dark';
import 'ace-builds/src-noconflict/theme-solarized_light';
import 'ace-builds/src-noconflict/theme-terminal';

function Compiler({ code1, setCode1, code2, setCode2 }) {
  const [output, setOutput] = useState('');
  const [pyodide, setPyodide] = useState(null);
  const [rundisable, setRundisable] = useState(false);
  const outputRef = useRef(null);

  // Load Pyodide from CDN
  useEffect(() => {
    const loadPyodide = async () => {
      const pyodidePkg = await window.loadPyodide({
        indexURL: "https://cdn.jsdelivr.net/pyodide/v0.23.4/full/"
      });
      setPyodide(pyodidePkg);
    };

    const loadScript = document.createElement('script');
    loadScript.src = 'https://cdn.jsdelivr.net/pyodide/v0.23.4/full/pyodide.js';
    loadScript.onload = loadPyodide;
    document.body.appendChild(loadScript);
  }, []);

  const handleRunPython = async () => {
    if (!pyodide) {
      setOutput("Pyodide is still loading...");
      return;
    }

    setRundisable(true);
    setOutput('');
    scrollToBottom();

    const fullCode = `${code1}\n\n${code2}`;
    try {
      pyodide.setStdout({
        batched: (text) => setOutput((prev) => prev + text),
      });
      pyodide.setStderr({
        batched: (text) => setOutput((prev) => prev + text),
      });

      await pyodide.runPythonAsync(fullCode);
    } catch (err) {
      setOutput((prev) => prev + '\n' + err.toString());
    } finally {
      setRundisable(false);
      scrollToBottom();
    }
  };

  const scrollToBottom = () => {
    if (outputRef.current) {
      outputRef.current.scrollTop = outputRef.current.scrollHeight;
    }
  };

  return (
    <div className="row mb-5">
      <h4 className="text-xl text-gray-700 bg-purple-100 mt-2">
        Enter your function code here
      </h4>
      <AceEditor
        mode="python"
        theme="monokai"
        value={code1}
        onChange={setCode1}
        placeholder="Write your function code here..."
        fontSize={20}
        showPrintMargin={true}
        showGutter={true}
        highlightActiveLine={true}
        wrapEnabled={true}
        className="border border-ring-blue-200  col-12"
        style={{ width: '100%', borderRadius: '10px', minHeight: '200px', maxHeight: '250px' }}
      />
      <h4 className="text-xl text-gray-700 bg-purple-100 mt-2">
        Enter the inputs and function call code here
      </h4>
      <AceEditor
        mode="python"
        theme="monokai"
        value={code2}
        onChange={setCode2}
        placeholder="Write your inputs and function call code here..."
        fontSize={20}
        showPrintMargin={true}
        showGutter={true}
        highlightActiveLine={true}
        wrapEnabled={true}
        className="border border-ring-blue-200  col-12"
        style={{ width: '100%', borderRadius: '10px', minHeight: '80px', maxHeight: '120px' }}
      />
      <div>
        <button
          className="btn btn-success rounded px-3 mt-2"
          disabled={rundisable}
          style={{ backgroundColor: "#377383" }}
          onClick={handleRunPython}
        >
          Run
        </button>
      </div>
      <h4 className="text-xl text-gray-700 mt-2">
        Output
      </h4>
      <div>
        <textarea
          id="output"
          ref={outputRef}
          readOnly
          value={output}
          className='form-control'
          style={{ width: '100%', minHeight: '200px', maxHeight: '800px' }}
        />
      </div>
    </div>
  );
}

export default Compiler;
